import React from 'react';

import API from '../../../../utils/API';
import FieldModal from '../../../../components/modals/fieldModal';

import { withRouter } from 'react-router-dom';

class CreateTemplateFromReportModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
        };
    }

    handleNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    };

    submit = async () => {
        this.setState({ submitting: true });
        const { eventId, orgId, updatedReport, toggle } = this.props;

        await API().patch(`Organizations/${orgId}/events/${eventId}/viewReports/${updatedReport._id}`, { isOrgTemplate: true })
            .then((res) => {
                if (res.data) {
                    this.props.updateReport();
                    toggle();
                }
            });
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { submitting, name, requiredFields } = this.state;

        return (
            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Create Template from Report"}
                    bodyHeaderText={''}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Submit' : 'Submitting...'}
                    actionButton={() => this.submit()}
                    actionButtonDisabled={submitting}
                ></FieldModal>
            </div>

        );
    }
}

export default withRouter(CreateTemplateFromReportModal);
